import React from "react"
import styled from "styled-components"

import { theme } from "./mixin"

const NavItemIconRow = ({
  text,
  onClick,
  connect,
  lastItem,
  showDisconnect,
  onDisconnect,
  to,
  blank
}) => {
  return (
    <>
      <a href={to} target={blank ? "_blank" : "_self"} rel="noreferrer">
        <CollapseNavItems
          connect={connect}
          lastItem={lastItem}
          onClick={onClick}
        >
          {text}
        </CollapseNavItems>
      </a>
    </>
  )
}

export default NavItemIconRow

const CollapseNavItems = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;
  cursor: pointer;
  border-radius: 24px;
  margin-bottom: ${({ lastItem }) => (lastItem ? 0 : "16px")};
  background: ${theme.white};
  color: ${theme.secondary};
  font-family: ${theme.titleFonts};
  font-weight: 700;
  transition: all 0.3s;
  :hover {
    color: ${theme.CTAcolor};
  }
`
